// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Auth.css - Styles for authentication components */

.auth-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: calc(100vh - 80px);
  padding: 40px 20px;
  background-color: #f8f9fa;
}

.auth-card {
  width: 100%;
  max-width: 450px;
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  padding: 40px;
  transition: all 0.3s ease;
}

.auth-card h2 {
  text-align: center;
  margin-bottom: 10px;
  color: #333;
  font-size: 28px;
}

.auth-subtitle {
  text-align: center;
  color: #666;
  margin-bottom: 30px;
  font-size: 16px;
}

.auth-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-group {
  position: relative;
}

.input-icon-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.input-icon {
  position: absolute;
  left: 15px;
  color: #6c757d;
  font-size: 18px;
}

.auth-form input[type="text"],
.auth-form input[type="email"],
.auth-form input[type="password"] {
  width: 100%;
  padding: 15px 15px 15px 45px;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 16px;
  transition: border-color 0.3s;
}

.auth-form input:focus {
  outline: none;
  border-color: #4a90e2;
  box-shadow: 0 0 0 2px rgba(74, 144, 226, 0.2);
}

.password-toggle {
  position: absolute;
  right: 15px;
  background: none;
  border: none;
  color: #6c757d;
  cursor: pointer;
  font-size: 18px;
  padding: 0;
}

.password-toggle:hover {
  color: #4a90e2;
}

.form-options {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  margin-top: -10px;
}

.remember-me,
.terms-checkbox {
  display: flex;
  align-items: center;
  gap: 5px;
  color: #666;
}

.forgot-password {
  color: #4a90e2;
  text-decoration: none;
}

.forgot-password:hover {
  text-decoration: underline;
}

.auth-button {
  background-color: #4a90e2;
  color: white;
  border: none;
  border-radius: 5px;
  padding: 15px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
}

.auth-button:hover {
  background-color: #3a7bc8;
}

.auth-button:disabled {
  background-color: #a0c1e8;
  cursor: not-allowed;
}

.auth-footer {
  text-align: center;
  margin-top: 30px;
  color: #666;
  font-size: 15px;
}

.auth-footer a {
  color: #4a90e2;
  text-decoration: none;
  font-weight: 600;
}

.auth-footer a:hover {
  text-decoration: underline;
}

.auth-error {
  background-color: #ffebee;
  color: #d32f2f;
  padding: 12px;
  border-radius: 5px;
  margin-bottom: 20px;
  font-size: 14px;
  border-left: 4px solid #d32f2f;
}

.auth-success {
  background-color: #e8f5e9;
  color: #2e7d32;
  padding: 12px;
  border-radius: 5px;
  margin-bottom: 20px;
  font-size: 14px;
  border-left: 4px solid #2e7d32;
}

/* Loading spinner */
.loading-spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 30px 0;
}

.loading-spinner::after {
  content: "";
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #4a90e2;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

/* Button spinner */
.spinner-border {
  display: inline-block;
  width: 1rem;
  height: 1rem;
  border: 2px solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: spin 0.75s linear infinite;
}

.spinner-border-sm {
  width: 1rem;
  height: 1rem;
  border-width: 2px;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Profile specific styles */
.profile-card {
  max-width: 600px;
}

.profile-avatar {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 30px;
}

.avatar-circle {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background-color: #4a90e2;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 40px;
  font-weight: bold;
  margin-bottom: 15px;
}

.edit-profile-button,
.change-password-button {
  background-color: transparent;
  color: #4a90e2;
  border: 1px solid #4a90e2;
  border-radius: 5px;
  padding: 8px 15px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  gap: 5px;
}

.edit-profile-button:hover,
.change-password-button:hover {
  background-color: #4a90e2;
  color: white;
}

.profile-info {
  margin-bottom: 30px;
}

.info-item {
  display: flex;
  margin-bottom: 15px;
  padding-bottom: 15px;
  border-bottom: 1px solid #eee;
}

.info-label {
  width: 150px;
  font-weight: 600;
  color: #555;
}

.info-value {
  flex: 1 1;
  color: #333;
}

.profile-actions {
  display: flex;
  gap: 10px;
}

.save-button {
  flex: 1 1;
}

.cancel-button {
  flex: 1 1;
  background-color: #e0e0e0;
  color: #333;
}

.cancel-button:hover {
  background-color: #d0d0d0;
}

.password-section {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #eee;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .auth-card {
    padding: 30px 20px;
  }
  
  .form-options {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
  
  .info-item {
    flex-direction: column;
  }
  
  .info-label {
    width: 100%;
    margin-bottom: 5px;
  }
  
  .profile-actions {
    flex-direction: column;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/Auth/Auth.css"],"names":[],"mappings":"AAAA,oDAAoD;;AAEpD;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,eAAe;AACjB;;AAEA;;;EAGE,WAAW;EACX,4BAA4B;EAC5B,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;EACjC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,8BAA8B;AAChC;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA,mBAAmB;AACnB;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,+BAA+B;EAC/B,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,4BAA4B;AAC5B;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;EAEE,6BAA6B;EAC7B,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;EAEE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,SAAO;EACP,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,SAAO;EACP,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;AACF","sourcesContent":["/* Auth.css - Styles for authentication components */\n\n.auth-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: calc(100vh - 80px);\n  padding: 40px 20px;\n  background-color: #f8f9fa;\n}\n\n.auth-card {\n  width: 100%;\n  max-width: 450px;\n  background-color: white;\n  border-radius: 10px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n  padding: 40px;\n  transition: all 0.3s ease;\n}\n\n.auth-card h2 {\n  text-align: center;\n  margin-bottom: 10px;\n  color: #333;\n  font-size: 28px;\n}\n\n.auth-subtitle {\n  text-align: center;\n  color: #666;\n  margin-bottom: 30px;\n  font-size: 16px;\n}\n\n.auth-form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.form-group {\n  position: relative;\n}\n\n.input-icon-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.input-icon {\n  position: absolute;\n  left: 15px;\n  color: #6c757d;\n  font-size: 18px;\n}\n\n.auth-form input[type=\"text\"],\n.auth-form input[type=\"email\"],\n.auth-form input[type=\"password\"] {\n  width: 100%;\n  padding: 15px 15px 15px 45px;\n  border: 1px solid #ddd;\n  border-radius: 5px;\n  font-size: 16px;\n  transition: border-color 0.3s;\n}\n\n.auth-form input:focus {\n  outline: none;\n  border-color: #4a90e2;\n  box-shadow: 0 0 0 2px rgba(74, 144, 226, 0.2);\n}\n\n.password-toggle {\n  position: absolute;\n  right: 15px;\n  background: none;\n  border: none;\n  color: #6c757d;\n  cursor: pointer;\n  font-size: 18px;\n  padding: 0;\n}\n\n.password-toggle:hover {\n  color: #4a90e2;\n}\n\n.form-options {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 14px;\n  margin-top: -10px;\n}\n\n.remember-me,\n.terms-checkbox {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  color: #666;\n}\n\n.forgot-password {\n  color: #4a90e2;\n  text-decoration: none;\n}\n\n.forgot-password:hover {\n  text-decoration: underline;\n}\n\n.auth-button {\n  background-color: #4a90e2;\n  color: white;\n  border: none;\n  border-radius: 5px;\n  padding: 15px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.3s;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n}\n\n.auth-button:hover {\n  background-color: #3a7bc8;\n}\n\n.auth-button:disabled {\n  background-color: #a0c1e8;\n  cursor: not-allowed;\n}\n\n.auth-footer {\n  text-align: center;\n  margin-top: 30px;\n  color: #666;\n  font-size: 15px;\n}\n\n.auth-footer a {\n  color: #4a90e2;\n  text-decoration: none;\n  font-weight: 600;\n}\n\n.auth-footer a:hover {\n  text-decoration: underline;\n}\n\n.auth-error {\n  background-color: #ffebee;\n  color: #d32f2f;\n  padding: 12px;\n  border-radius: 5px;\n  margin-bottom: 20px;\n  font-size: 14px;\n  border-left: 4px solid #d32f2f;\n}\n\n.auth-success {\n  background-color: #e8f5e9;\n  color: #2e7d32;\n  padding: 12px;\n  border-radius: 5px;\n  margin-bottom: 20px;\n  font-size: 14px;\n  border-left: 4px solid #2e7d32;\n}\n\n/* Loading spinner */\n.loading-spinner {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 30px 0;\n}\n\n.loading-spinner::after {\n  content: \"\";\n  width: 40px;\n  height: 40px;\n  border: 4px solid #f3f3f3;\n  border-top: 4px solid #4a90e2;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n/* Button spinner */\n.spinner-border {\n  display: inline-block;\n  width: 1rem;\n  height: 1rem;\n  border: 2px solid currentColor;\n  border-right-color: transparent;\n  border-radius: 50%;\n  animation: spin 0.75s linear infinite;\n}\n\n.spinner-border-sm {\n  width: 1rem;\n  height: 1rem;\n  border-width: 2px;\n}\n\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* Profile specific styles */\n.profile-card {\n  max-width: 600px;\n}\n\n.profile-avatar {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-bottom: 30px;\n}\n\n.avatar-circle {\n  width: 100px;\n  height: 100px;\n  border-radius: 50%;\n  background-color: #4a90e2;\n  color: white;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 40px;\n  font-weight: bold;\n  margin-bottom: 15px;\n}\n\n.edit-profile-button,\n.change-password-button {\n  background-color: transparent;\n  color: #4a90e2;\n  border: 1px solid #4a90e2;\n  border-radius: 5px;\n  padding: 8px 15px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: all 0.3s;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.edit-profile-button:hover,\n.change-password-button:hover {\n  background-color: #4a90e2;\n  color: white;\n}\n\n.profile-info {\n  margin-bottom: 30px;\n}\n\n.info-item {\n  display: flex;\n  margin-bottom: 15px;\n  padding-bottom: 15px;\n  border-bottom: 1px solid #eee;\n}\n\n.info-label {\n  width: 150px;\n  font-weight: 600;\n  color: #555;\n}\n\n.info-value {\n  flex: 1;\n  color: #333;\n}\n\n.profile-actions {\n  display: flex;\n  gap: 10px;\n}\n\n.save-button {\n  flex: 1;\n}\n\n.cancel-button {\n  flex: 1;\n  background-color: #e0e0e0;\n  color: #333;\n}\n\n.cancel-button:hover {\n  background-color: #d0d0d0;\n}\n\n.password-section {\n  margin-top: 20px;\n  padding-top: 20px;\n  border-top: 1px solid #eee;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .auth-card {\n    padding: 30px 20px;\n  }\n  \n  .form-options {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 10px;\n  }\n  \n  .info-item {\n    flex-direction: column;\n  }\n  \n  .info-label {\n    width: 100%;\n    margin-bottom: 5px;\n  }\n  \n  .profile-actions {\n    flex-direction: column;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
